// Widget «هشدار بالینی» سربرگ مشترک مراجعه‌کننده (AC-CLN-060.2؛ بخش cln.alerts فقط برای نقش‌های بالینی از سرور می‌آید و فقط شمارنده دارد —
// C-AGENT-659). متن هشدارها از GET /clinical/patients/{id}/alerts خوانده می‌شود (مشاهده در سرور Audit می‌شود).
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@phoenix/i18n';
import type { PatientHeaderWidgetProps } from '../patients/headerWidgets';
import { ClinicalAlertsBar, useClinicalAlerts } from './common';

export function ClinicalAlertsWidget({ section, patientId }: PatientHeaderWidgetProps) {
  const { t } = useTranslation('cln');
  const count = Number(section.entries.find((entry) => entry.key === 'count')?.value ?? 0);
  const alerts = useClinicalAlerts(count > 0 ? patientId : null);
  return (
    <Box data-testid="clinical-alerts-widget" data-count={count}>
      <Typography variant="caption" color="text.secondary" component="div">
        {t('cln:alerts.title')}
      </Typography>
      {count === 0 ? (
        <Typography variant="body2">{t('cln:alerts.none')}</Typography>
      ) : (
        <ClinicalAlertsBar data={alerts.data} compact />
      )}
    </Box>
  );
}
